export default {
  marginTopSmallMultiplier: 2,
  marginTopMediumMultiplier: 2,
  marginTopLargeMultiplier: 2,
  marginTopXLargeMultiplier: 2,
  marginBottomSmallMultiplier: 0,
  marginBottomMediumMultiplier: 0,
  marginBottomLargeMultiplier: 0,
  marginBottomXLargeMultiplier: 0,
  grayMarginTopSmallMultiplier: 8,
  grayMarginTopMediumMultiplier: 8,
  grayMarginTopLargeMultiplier: 8,
  grayMarginTopXLargeMultiplier: 8,
  grayPaddingTopSmallMultiplier: 2,
  grayPaddingTopMediumMultiplier: 2,
  grayPaddingTopLargeMultiplier: 2,
  grayPaddingTopXLargeMultiplier: 2,
  grayPaddingBottomSmallMultiplier: 7,
  grayPaddingBottomMediumMultiplier: 10,
  grayPaddingBottomLargeMultiplier: 10,
  grayPaddingBottomXLargeMultiplier: 10
}
